import { EnvironmentItem } from 'scenes/ProjectSettings/scenes/Environments/EnvironmentsList/Environment/types';
import { PartialRootState } from './types';

export const getEnvironmentsList = ({
  environments,
}: PartialRootState): EnvironmentItem[] => environments.list;

export const getEnvironmentsIsLoading = ({
  environments,
}: PartialRootState): boolean => environments.isLoading;
